import { render, staticRenderFns } from "./PageHelper.vue?vue&type=template&id=371f7f2a&scoped=true&"
import script from "./PageHelper.vue?vue&type=script&lang=js&"
export * from "./PageHelper.vue?vue&type=script&lang=js&"
import style0 from "./PageHelper.vue?vue&type=style&index=0&id=371f7f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f7f2a",
  null
  
)

export default component.exports